var UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
export var stripUUIDFromPath = function stripUUIDFromPath(path) {
  return path.replace(UUID_REGEX, '<UUID>');
};